import { PlusIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";

const iconComponents = {
  PlusIcon: PlusIcon,
};

interface FullWidthAsyncButtonProps {
  className?: string;
  icon?: keyof typeof iconComponents;
  text: string;
  loadingText: string;
  onClick: () => Promise<void>;
  disabled?: boolean;
  isSkeleton?: boolean;
}

const FullWidthAsyncButton: React.FC<FullWidthAsyncButtonProps> = ({
  className,
  icon,
  text,
  loadingText,
  onClick,
  disabled = false,
  isSkeleton = false,
}) => {
  const [loading, setLoading] = useState(false);
  const Icon = icon ? iconComponents[icon] : null;

  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={`${className} group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-25`}
      onClick={handleClick}
      disabled={disabled || loading || isSkeleton}
    >
      {isSkeleton && (
        <span className="flex items-center pl-2">
          <ClipLoader color="white" speedMultiplier={0.6} size={"1.25rem"} />
        </span>
      )}

      {loading && (
        <>
          {loadingText}
          <span className="flex items-center pl-2">
            <ClipLoader color="white" speedMultiplier={0.6} size={"1.25rem"} />
          </span>
        </>
      )}

      {!loading && !isSkeleton && (
        <>
          {text}
          {Icon && (
            <span className="flex items-center pl-2">
              <Icon className="h-5 w-5 text-white" aria-hidden="true" />
            </span>
          )}
        </>
      )}
    </button>
  );
};

export default FullWidthAsyncButton;
